import {
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILURE,
  FETCH_DOS_TASKS_SUCCESS,
  FETCH_DOS_TASKS_FAILURE,
  FETCH_TASK_OWNERS_SUCCESS,
  FETCH_TASK_OWNERS_FAILURE,
  FETCH_TASK_CENTRES_SUCCESS,
  FETCH_TASK_TYPES_SUCCESS,
} from './actions';
import TaskCentreModel from './TaskCentre';
import TaskTypeModel from './TaskType';
import { Map, List } from 'immutable';
import { ApiResponseHelper, moment } from 'omni-common-ui';
import camelCase from 'lodash.camelcase';
import {
  getExamBasePath,
  getProgressReportBasePath,
  getUnitReportBasePath,
} from 'domain/CourseType';

export default function taskFitlerResult(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_TASKS_SUCCESS:
      return onSuccess(action);
    case FETCH_TASKS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}


export function dosTaskFilterResult(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_DOS_TASKS_SUCCESS:
      return onSuccess(action);
    case FETCH_DOS_TASKS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

export function taskOwnersResult(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_TASK_OWNERS_SUCCESS:
      return onTaskOwnerSuccess(action);
    case FETCH_TASK_OWNERS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

export function taskCentres(state = new List(), action) {
  switch (action.type) {
    case FETCH_TASK_CENTRES_SUCCESS:
      return new List(action.payload.map((taskCentre) => new TaskCentreModel(taskCentre)));
    default:
      return state;
  }
}

export function taskTypes(state = new List(), action) {
  switch (action.type) {
    case FETCH_TASK_TYPES_SUCCESS:
      return new List(action.payload.map((taskType) => new TaskTypeModel(taskType)));
    default:
      return state;
  }
}

function onSuccess(action) {
  const tasks = [];
  action.payload.tasks.map((task) => {
    const timeZone = task.timeZone;
    const dueDateUtc = moment.utc(task.dueDate);
    const dueDate = timeZone ?
        dueDateUtc.clone().tz(timeZone) :
        dueDateUtc.clone().local();
    const now = timeZone ?
        moment().tz(timeZone) :
        moment().local();
    let displayDueDate = dueDate.format('YYYY-MM-DD');
    if (dueDate - now.endOf('day') >= 0 &&
      now.endOf('day').add(1, 'day') - dueDate >= 0) {
      displayDueDate = 'Tomorrow';
    } else if (dueDate - now.startOf('day') >= 0 &&
      now.endOf('day') - dueDate >= 0) {
      displayDueDate = 'Today';
    }
    let redirectUrl = '';
    let owner = '';

    if (task.firstName && task.lastName) {
      owner = `${task.firstName} ${task.lastName}`;
    } else if (task.firstName) {
      owner = task.firstName;
    } else if (task.lastName) {
      owner = task.lastName;
    }


    /*
      MarkAttendance            MA
      CoverInClass              CIC
      ProgressTest              PT
      UnitReport                UR
      UnitReportApproval        URA
      ProgressReport            PR
      LevelReportApproval       LRA
      AssignHomework            AH
      MarkPaperBaseHomework     MPBH
    */

    const actionLinks = sanitiseActionLinks(task.actionLinks ? JSON.parse(task.actionLinks) : {});
    if (task.taskTypeCode === 'MA') {
      redirectUrl = `/group/${actionLinks.groupId}/attendance/session/${actionLinks.sessionId}`;
    } else if (task.taskTypeCode === 'CIC') {
      redirectUrl = `/group/${actionLinks.groupId}/session/${actionLinks.sessionId}/covered-in-class`;
    } else if (task.taskTypeCode === 'PT' || task.taskTypeCode === 'PTWS') {
      redirectUrl = `/group/${actionLinks.groupId}/progress-test/${[actionLinks.progressTestIndex - 1]}/course`;
    } else if (actionLinks.progressTestType === 'MIDTERM_FINAL') {
      const examBasePath = getExamBasePath(task);
      redirectUrl = `/group/${actionLinks.groupId}/${examBasePath}/${[actionLinks.progressTestIndex - 1]}/course`;
    } else if (task.taskTypeCode === 'UR') {
      const unitReportPath = getUnitReportBasePath(task);
      redirectUrl = `/group/${actionLinks.groupId}/${unitReportPath}/${actionLinks.unitReportId}`;
    } else if (task.taskTypeCode === 'URA') {
      const unitReportPath = getUnitReportBasePath(task);
      redirectUrl = `/group/${actionLinks.groupId}/${unitReportPath}/${actionLinks.unitReportId}/dos-approval`;
    } else if (task.taskTypeCode === 'PR') {
      const progressReportPath = getProgressReportBasePath(task);
      redirectUrl = `/group/${actionLinks.groupId}/${progressReportPath}/${actionLinks.groupCompulsoryIdpId}`;
    } else if (task.taskTypeCode === 'LRA') {
      const progressReportPath = getProgressReportBasePath(task);
      redirectUrl = `/group/${actionLinks.groupId}/${progressReportPath}/${actionLinks.groupCompulsoryIdpId}/dos-approval`;
    } else if (task.taskTypeCode === 'AH') {
      redirectUrl = `/group/${actionLinks.groupId}/assign-homework/session/${actionLinks.sessionId}`;
    } else if (task.taskTypeCode === 'MPBH') {
      redirectUrl = `/group/${actionLinks.groupId}/homework/session/${actionLinks.sessionId}/paper-based/day`;
    }

    const newTask = Object.assign({},
        task,
        { dueDate: displayDueDate, redirectUrl, owner, actionLinks });

    tasks.push(newTask);
    return true;
  });
  return ApiResponseHelper.create(Object.assign({}, action.payload, { tasks }));
}

function onTaskOwnerSuccess(action) {
  const taskOwners = [];
  action.payload.map((owner) => {
    taskOwners.push({
      name: `${owner.firstName} ${owner.lastName}`,
      id: owner.id,
    });
    return false;
  });

  return { data: taskOwners };
}

function sanitiseActionLinks(actionLinks) {
  return Object.getOwnPropertyNames(actionLinks)
    .reduce((newActionLinks, prop) => Object.assign(newActionLinks, {
      [camelCase(prop)]: actionLinks[prop],
    }), {});
}



// WEBPACK FOOTER //
// ./data/Tasks/reducer.js